import { useCallback, useState } from "react"
import { Surname } from "../entities/surname"
import { surnameListService } from "../services/surname/surnameListService"
import { useAuth } from "./useAuth"

export function useSurnameListService(): {
	surnameList: Surname[]
	isLoading: boolean
	error: null | Error
	fetchSurnameList: (filter?: Parameters<typeof surnameListService>[0]) => Promise<void>
} {
	const { token } = useAuth()
	const [surnameList, setSurnameList] = useState<Surname[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState<Error | null>(null)

	const fetchSurnameList = useCallback(
		async (filter: Parameters<typeof surnameListService>[0] = {}) => {
			try {
				setIsLoading(true)
				const data = await surnameListService(filter, token)
				setSurnameList(data)
			} catch (error) {
				setError(error as Error)
			} finally {
				setIsLoading(false)
			}
		},
		[token],
	)

	return { surnameList, isLoading, error, fetchSurnameList }
}
